import { Modal, Typography, Button, Stack } from "@mui/material";
import { ContentModal } from "components/Surfaces/ContentModal/ContentModal";
import { formatCnpj } from "utils/Masks/Masks";
import { IconEnterprise } from "components/Icons/IconEnterprise";

export default function LinkCnpjSuccessModal({ open, onClose, cnpj, name }) {
  if (!open) return null;

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus disableEnforceFocus>
      <ContentModal
        borderRadius={"8px"}
        p={"40px 32px"}
        display={"flex"}
        flexDirection={"column"}
        textAlign={"center"}
        gap={"28px"}
        sx={{
          width: "450px",
        }}
      >
        <Typography color="#2CABF9" fontSize={"24px"} fontWeight={600}>
          Acesso vinculado com sucesso!
        </Typography>
        <Typography fontSize={"14px"} fontWeight={500} textAlign={"left"}>
          A conta industrial informada, foi vinculada a seu grupo de acessos.
          Você pode editar seus acesso a qualquer momento na aba “Meus CNPJs”
        </Typography>
        <Stack
          borderRadius={"8px"}
          border={"2px solid #053462"}
          p={"17px"}
          alignItems="center"
          justifyContent="space-between"
          direction={"row"}
          gap={2}
        >
          <IconEnterprise width="35px" height="35px" color="#053462" />

          <Stack textAlign="left" flex={1}>
            <Typography fontSize={12} fontWeight={600} color="#636363">
              {formatCnpj(cnpj)}
            </Typography>
            <Typography fontSize={18} fontWeight={600} color="#053462" mt={0.5}>
              {name}
            </Typography>
          </Stack>
        </Stack>
        <Button
          onClick={onClose}
          sx={{
            alignSelf: "flex-end",
            color: "#2CABF9",
            fontSize: "18px",
            fontWeight: 700,
          }}
        >
          OK
        </Button>
      </ContentModal>
    </Modal>
  );
}
